import React, { memo } from 'react'
import { Link } from '@reach/router'
import { Hidden, IconButton } from '@material-ui/core'
import { ReactComponent as Whatsapp } from '../../assets/svgs/whatsapp.svg'
import { Home2 as Home } from '@styled-icons/remix-line/Home2'
import { pageLinks } from '../../shared/constants/links'
import isActiveLink from '../../shared/helpers/isActiveLink'
import * as Styled from './styled'

const Navbar = () => {

  return (
    <Styled.Wrapper>
      <nav>
        <Styled.LinkList>
          <Hidden mdDown>
            <Styled.Item padding='0 10px'>
              <Link
                swipe='true'
                duration={0.3}
                direction='left'
                to='/'
                getProps={isActiveLink}
              >
                <Home style={{ width: 20, height: 20 }} />
              </Link>
            </Styled.Item>
            {pageLinks.map(({ title, route }, i) => (
              <Styled.Item
                divider={Number(i !== pageLinks.length - 1)}
                key={`navbarLink${route}`}
                padding='0 9px'
              >
                {route.startsWith('http') ? (
                  <a href={route} target='_blank' rel='noopener noreferrer'>
                    {title}
                  </a>
                ) : (
                  <Link
                    swipe='true'
                    duration={0.3}
                    direction='left'
                    to={route}
                    getProps={isActiveLink}
                  >
                    {title}
                  </Link>
                )}
              </Styled.Item>
            ))}
          </Hidden>
          <Hidden lgUp>
            <Styled.Item padding='0'>
              <IconButton
                disableRipple
                className='noHoverBg'
                size='small'
                edge='end'
                color='inherit'
                aria-label='Enviar mensagem via whatsapp'
              >
                <a
                  href='https://wa.me/5521970646570'
                  rel='noopener noreferrer'
                  target='_blank'
                >
                  <Whatsapp
                    style={{
                      height: 20,
                      width: 20
                    }}
                  />
                </a>
              </IconButton>
            </Styled.Item>
          </Hidden>
        </Styled.LinkList>
      </nav>
    </Styled.Wrapper>
  )
}

export default memo(Navbar)
